import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { LookupModel } from '../models';
import { of } from 'rxjs';
import * as moment from 'moment';

@Injectable({ providedIn: 'root' })
export class LookupService {
  constructor(private apiService: ApiService) {}

  getRoles(): Observable<string[]> {
    return this.apiService.get(`/roles`).pipe(map(data => data.data));
  }

  getEmployees(): Observable<LookupModel[]> {
    return this.apiService.get(`/employees/get-ddl`).pipe(map(data => data.data));
  }

  getRegions(): Observable<LookupModel[]> {
    return this.apiService.get(`/regions/get-all-regions`).pipe(map(data => data.data));
  }

  getFieldSizes(): Observable<LookupModel[]> {
    return this.apiService.get(`/field-sizes/get-ddl`).pipe(map(data => data.data));
  }

  getFieldTypes(): Observable<LookupModel[]> {
    return this.apiService.get(`/field-types/get-ddl`).pipe(map(data => data.data));
  }

  getProgramSports(): Observable<LookupModel[]> {
    return this.apiService.get(`/program-sports/get-ddl`).pipe(map(data => data.data));
  }

  getWeekDays(): Observable<LookupModel[]> {
    return this.apiService.get(`/reservations/week-days`).pipe(map(data => data.data));
  }

  getFields(): Observable<LookupModel[]> {
    return this.apiService.get(`/fields/get-ddl`).pipe(map(data => data.data));
  }

  getBranches(providerId?: number): Observable<LookupModel[]> {
    return this.apiService.get(`/branches/get-ddl/${providerId}`).pipe(map(data => data.data));
  }

  getTimeDDL(): Observable<any[]> {
    let stratTime = moment('04-20-2021 00:00', 'MM-DD-YYYY HH:mm');
    const endTime = moment('04-20-2021 23:59', 'MM-DD-YYYY HH:mm');
    const result: any[] = [];

    while (stratTime <= endTime) {
      result.push({
        id: moment(stratTime, 'HH:mm:ss').utc().format('HH:mm:ss'),
        name: moment(stratTime).format('hh:mm A'),
      });
      stratTime = stratTime.add(30, 'minutes');
    }

    return of(result);
  }
}
